import { TranslocoService } from '@ngneat/transloco';
import moment from 'moment';
import { Deserializable } from './deserializable';

export class BaseModel implements Deserializable {

  // columns
  id: number;
  created_at: any; // tslint:disable-line: variable-name
  created_from?: any; // tslint:disable-line: variable-name
  updated_at: any; // tslint:disable-line: variable-name
  updated_from?: any; // tslint:disable-line: variable-name
  updateable: boolean;
  deletable: boolean;
  misc: any;

  // pseudo attributes for client handling
  temp: any;
  pivot: any;

  // control attributes
  loaded = false;

  // helper attributes
  transloco: TranslocoService;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.loaded = true;
    return this;
  }

  getLang(attribute: string, language: string): string {
    language = language.toUpperCase();
    if (this.hasOwnProperty(attribute) && this[attribute] !== null && typeof this[attribute].hasOwnProperty(language)) {
      return this[attribute][language];
    } else {
      return this[attribute];
    }
  }

  getLastChanged(): string {
    const data: Array<string> = [];
    if (this.updated_from) {
      data.push(this.updated_from);
    }
    if (this.updated_at) {
      data.push(moment(this.updated_at).format('DD.MM.YYYY'));
    }
    return data.join(' / ');
  }

  getMisc(key: string, fallback: any = null): any {
    return (this.misc && this.misc[key]) ? this.misc[key] : fallback;
  }

  setTranslocoService(transloco: TranslocoService): void {
    this.transloco = transloco;
  }

}
